import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  Input,
  InputSignal,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { DataLengthComponent } from './kpi-count/kpi-count.component';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { KpiCardI } from '../../../interfaces/config';

@Component({
  selector: 'kpi-card',
  standalone: true,
  imports: [
    NgStyle,
    NgClass,
    DataLengthComponent,
    ButtonModule,
    RouterLink,
    AsyncPipe,
  ],
  templateUrl: './kpi-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiCardComponent {
  cardConfig: InputSignal<KpiCardI> = input.required();
}
